import { FolderTree, Plus } from 'lucide-react'

import { Button } from '../button'

/** Shopify empty state: a soft icon disc, a short title, one line of help and the page's main action. */
export const NoData = ({
  openCreateDialog,
  title,
  description,
  btnText
}: {
  openCreateDialog?: () => void
  title: string
  description?: string
  btnText?: string
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-14 text-center">
      <span className="mb-4 grid size-20 place-items-center rounded-full bg-subdued" aria-hidden="true">
        <FolderTree className="size-8 text-faint" />
      </span>
      <h3 className="text-heading-md text-ink">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {btnText && (
        <Button onClick={openCreateDialog} className="mt-4">
          <Plus />
          {btnText}
        </Button>
      )}
    </div>
  )
}
